<!-- Header -->
@if (slideAuthorFacade.annotationLabelInfo$(annotation.id, translate) | async; as label) {
  <medsurf-slide-edit-header
    [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ANNOTATION_KEYMAP"
    [label]="label"
  [type]="'enum.annotation_type.Keymap'"></medsurf-slide-edit-header>
}
<!-- Content -->
<div #edit_overlay_template_scroll_panel
  class="flex flex-1 overflow-auto justify-content-center">
  <!-- Accordion -->
  <p-accordion [activeIndex]="[0, 1, 2]"
    [multiple]="true"
    styleClass="no_border"
    class="w-full h-full ml-3 mr-3">
    <p-accordionTab [header]="'global.layout' | translate"
      headerStyleClass="uppercase">
      <!-- Text Layout -->
      <medsurf-slide-edit-keymap-font-style-form [class]="'w-full'"></medsurf-slide-edit-keymap-font-style-form>

      <!-- Spacing Layout -->
      <medsurf-slide-edit-keymap-spacing-style-form [class]="'w-full'"></medsurf-slide-edit-keymap-spacing-style-form>
    </p-accordionTab>
    <p-accordionTab headerStyleClass="uppercase">
      <ng-template pTemplate="header">
        <span class="flex align-items-center gap-2 w-full">
          <span class="flex flex-1 font-bold white-space-nowrap uppercase">
            {{ 'global.keymap_columns' | translate }}
          </span>
          @if (slideAuthorFacade.currentSelectedSlideKeymap$ | async; as keymap) {
            <medsurf-design-input-menu
              [formField]="false"
              [name]="'keymap_column_menu'"
              [tooltipLabel]="'title' | translate"
              [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
              [iconOpen]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
              [iconClose]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
              [loadContext]="{type: 'keymapColumn', keymap}"
              [loadMenuItems]="getKeymapColumnMenuItems"
            (click)="$event.stopPropagation()"></medsurf-design-input-menu>
          }
        </span>
      </ng-template>
      <!-- Keymap Columns -->
      <medsurf-slide-edit-keymap-columns [class]="'w-full'"></medsurf-slide-edit-keymap-columns>
    </p-accordionTab>
  </p-accordion>
</div>
